export const labelsQueryKeys = {
    all: ['labels'],
};